import { BRANDS } from "@/lib/site";
import { Reveal } from "@/components/Reveal";

export const BrandWall = ({ heading = true, dark = false }) => {
  return (
    <section
      className={dark ? "py-24 md:py-28 bg-charcoal-900 text-white relative overflow-hidden" : "py-24 md:py-28 border-t border-border"}
      data-testid="brand-wall"
    >
      {dark && <div className="absolute inset-0 grain-overlay opacity-30" />}
      <div className="container-edge relative">
        {heading && (
          <Reveal>
            <div className="text-center max-w-3xl mx-auto">
              <p className={`eyebrow flex items-center justify-center gap-3 ${dark ? "text-white/60" : ""}`}>
                <span className="divider-gold" /> Brands We Represent <span className="divider-gold" />
              </p>
              <h2 className={`display-3 mt-6 ${dark ? "text-white" : ""}`}>
                Representing leading brands for <span className="italic text-gold">intelligent living</span> and exceptional interiors.
              </h2>
            </div>
          </Reveal>
        )}

        <div className="mt-16 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-px bg-border">
          {BRANDS.map((b, i) => (
            <Reveal
              key={b.name}
              delay={(i % 6) * 80}
              className="group relative aspect-[4/3] flex items-center justify-center p-8 bg-white overflow-hidden transition-colors"
            >
              <img
                src={b.logo}
                alt={b.name}
                loading="lazy"
                className="max-h-[70%] max-w-[80%] object-contain transition-all duration-700 grayscale opacity-70 group-hover:grayscale-0 group-hover:opacity-100 group-hover:scale-105"
                data-testid={`brand-logo-${b.name.toLowerCase()}`}
              />
              <span className="absolute bottom-3 left-1/2 -translate-x-1/2 text-[10px] uppercase tracking-[0.22em] text-charcoal-400 opacity-0 group-hover:opacity-100 transition-opacity">
                {b.name}
              </span>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
